import { ZUid, zUid } from "src/types/zUid";
import { z } from "zod";

export const zChatInfo = z.object({
  id: zUid,
  name: z.string(),
  userIds: zUid.array(),
  ownerUserId: zUid,
});

export type ZChatInfo = z.infer<typeof zChatInfo>;

export type RCNewChatFormData = {
  name: string;
  userIds: ZUid[];
};
